import React from "react";
import PropTypes from "prop-types";
import { Dropdown } from "semantic-ui-react";
import { connect } from "react-redux";

/**
 * ContextSwitcher: (props) => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Dropdown selection component which allows the user to switch
 * the current context by way of selecting from a list.
 *
 * @param {*} props
 */
const ContextSwitcher = props => (
  <div className="ax-context-switcher">
    <Dropdown
      placeholder="Kontext"
      search
      selection
      options={props.contexts}
      onChange={props.onContextSelected}
      value={props.currentContext}
    />
  </div>
);

ContextSwitcher.propTypes = {
  /**
   * onContextSelected: (event, sender) => ()
   * Function to be called when the dropdown selection
   * has changed.
   */
  onContextSelected: PropTypes.func.isRequired,

  /**
   * currentContext: String
   * String identifier of the currently selected context
   */
  currentContext: PropTypes.string,

  /**
   * contexts: [Object]
   * Array of accessible contexts (transformed for Dropdown)
   */
  contexts: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired
    })
  ).isRequired
};

ContextSwitcher.defaultProps = {
  currentContext: null
};

/**
 * Transformes the contexts list provided per Redux into a
 * prop for dropdown
 */
const mapStateToProps = state => ({
  contexts: state.fs.contexts
    ? state.fs.contexts.map(context => ({
        key: context.id,
        value: context.id,
        text: context.displayName
      }))
    : []
});

export default connect(mapStateToProps)(ContextSwitcher);



// WEBPACK FOOTER //
// ./src/components/contextbar/ContextSwitcher.js